import { apiSlice } from 'api/apiSlice'
import Cookies from 'js-cookie'
import { ProductVariantSneakersResponse } from 'productTemplate/types/ProductVariant'
import { STORAGE } from 'shared/enums/SitePreferences'
import { PriceBreakdown } from 'shared/types/PriceBreakdown'

type GetPriceBreakdownParams = {
  boxCondition: string
  countryCode: string
  isInstantShip: boolean
  priceCents: number
  productId: string
  productTemplateId: string
  shoeCondition: string
  size: string
}

type GetPricesParams = {
  countryCode: string
  productTemplateId: string
  currency?: string // Used to bust cache for currency changes
}

const productVariantsApi = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    getBuyBarCopy: build.query({
      query: ({ slug, country }) => ({
        app: 'sneakers',
        method: 'GET',
        url: `/web-api/v1/product_variants/buy_bar_copies?productTemplateId=${slug}&countryCode=${country}&timestamp=${new Date().getTime()}`,
      }),
    }),
    getPrices: build.query<ProductVariantSneakersResponse[], GetPricesParams>({
      query: (params) => ({
        app: 'sneakers',
        method: 'GET',
        params: {
          ...params,
          currency: Cookies.get(STORAGE.CURRENCY),
        },
        url: `/web-api/v1/product_variants`,
      }),
    }),
    getPriceBreakdown: build.query<PriceBreakdown, GetPriceBreakdownParams>({
      query: (params) => ({
        app: 'sneakers',
        method: 'GET',
        params,
        url: `/web-api/v1/product_variants/price_breakdown`,
      }),
    }),
  }),
})

export const {
  useGetBuyBarCopyQuery,
  useGetPricesQuery,
  useGetPriceBreakdownQuery,
  useLazyGetPricesQuery,
  useLazyGetPriceBreakdownQuery,
} = productVariantsApi
